import { createGitBook } from "@gitbook/embed";
import type { GitBookEmbeddableConfiguration } from "@gitbook/embed";
import {
  getHelpCenterEmbedConfig,
  HelpCenterEmbedAction
} from "@/feature-flags/flags-help-center";

export const GITBOOK_VISITOR_TOKEN_THRESHOLD_MS = 5 * 60 * 1000;
const SESSION_STORAGE_KEY = "help_center_visitor_token";

export const HELP_CENTER_SECTION_PATHS = {
  beranda: "/",
  dokumentasi: "/documentation",
  berita: "/news"
} as const;

export interface HelpCenterTokenCache {
  token: string;
  siteUrl: string;
  expiresAt: string;
}

export function buildGitBookIframeSrc(siteUrl: string, token: string): string {
  const gitbook = createGitBook({ siteURL: siteUrl });
  return gitbook.getFrameURL({ visitor: { token } });
}

type HelpCenterFrame = {
  navigateToPage: (path: string) => void;
};

export function buildHelpCenterEmbedConfigure(
  frame: HelpCenterFrame,
  onActionClick?: (action: HelpCenterEmbedAction) => void
): Partial<GitBookEmbeddableConfiguration> {
  const config = getHelpCenterEmbedConfig();

  return {
    tabs: config.tabs as ('assistant' | 'docs' | 'search')[],
    trademark: config.trademark,
    actions: config.actions.map(action => ({
      icon: action.icon as any,
      label: action.label,
      onClick: () => {
        onActionClick?.(action);
        frame.navigateToPage(action.path);
      }
    })),
    greeting: { title: "", subtitle: "" },
    suggestions: [],
    tools: []
  };
}

export function isNearExpiry(expiresAt: string): boolean {
  return (
    new Date(expiresAt).getTime() - Date.now() <=
    GITBOOK_VISITOR_TOKEN_THRESHOLD_MS
  );
}

export function readCachedToken(): HelpCenterTokenCache | null {
  try {
    const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeCachedToken(data: HelpCenterTokenCache): void {
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));
  } catch {
    // sessionStorage unavailable — in-memory cache remains
  }
}

export function clearCachedToken(): void {
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
}
